import React, { createContext, useContext, useEffect, useMemo } from 'react';

/**
 * 配置类型定义
 */
export const IConfig = {
  // 基础信息
  clientId: '',
  clientName: '',
  projectName: '',
  version: '',
  
  // 主题配置
  theme: {
    name: '',
    primary: '',
    primaryHover: '',
    accent: '',
    neutral: '',
    background: '',
    surface: '',
    text: '',
    textSecondary: '',
  },
  
  // 布局配置
  layout: {
    headerHeight: '',
    sidebarWidth: '',
    sidebarCollapsedWidth: '',
    footerHeight: '',
    maxContentWidth: '',
    borderRadius: '',
    shadow: '',
  },
  
  // 组件配置
  components: {
    button: {
      primary: {
        backgroundColor: '',
        color: '',
        hoverBackgroundColor: '',
      },
      secondary: {
        backgroundColor: '',
        color: '',
        hoverBackgroundColor: '',
      },
    },
    card: {
      backgroundColor: '',
      borderColor: '',
      shadow: '',
    },
    navigation: {
      backgroundColor: '',
      activeColor: '',
      hoverColor: '',
    },
  },
  
  // 功能配置
  features: {
    enableSearch: false,
    enableTimeline: false,
    enableCollections: false,
    enableSharing: false,
    enableExport: false,
    enableAnalytics: false,
  },
  
  // 登录配置
  auth: {
    loginType: 'local', // 'local' | 'sso' | 'qrcode'
    ssoUrl: '',
    qrCodeApi: '',
    localLoginApi: '',
  },
  
  // 内容配置
  content: {
    logo: '',
    favicon: '',
    title: '',
    description: '',
    keywords: [],
  },
  
  // API配置
  api: {
    baseUrl: '',
    timeout: 0,
    retryCount: 0,
  },
  
  // 第三方服务配置
  thirdParty: {
    analytics: {
      enabled: false,
      trackingId: '',
    },
    maps: {
      enabled: false,
      apiKey: '',
    },
  },
};

/**
 * 客户端配置定义
 */
const CLIENT_CONFIGS = {
  'client-a': {
    clientId: 'client-a',
    clientName: '国网能源院',
    projectName: '政策研究平台',
    version: '1.0.0',
    
    theme: {
      name: 'green',
      primary: 'rgb(30,161,139)',
      primaryHover: '#2b568c',
      accent: '#10b981',
      neutral: '#333c4d',
      background: '#ffffff',
      surface: '#f8f9fa',
      text: 'rgb(30,161,139)',
      textSecondary: '#6b7280',
      button:'rgb(30,161,139)',
    },
    
    layout: {
      headerHeight: '64px',
      sidebarWidth: '280px',
      sidebarCollapsedWidth: '80px',
      footerHeight: '60px',
      maxContentWidth: '1200px',
      borderRadius: '8px',
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
    
    components: {
      button: {
        primary: {
          backgroundColor: '#1ea18b',
          color: '#ffffff',
          hoverBackgroundColor: '#2b568c',
        },
        secondary: {
          backgroundColor: '#f3f4f6',
          color: '#374151',
          hoverBackgroundColor: '#e5e7eb',
        },
      },
      card: {
        backgroundColor: '#ffffff',
        borderColor: '#e5e7eb',
        shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      },
      navigation: {
        backgroundColor: '#ffffff',
        activeColor: '#1ea18b',
        hoverColor: '#f3f4f6',
      },
    },
    
    features: {
      enableSearch: true,
      enableTimeline: true,
      enableCollections: true,
      enableSharing: true,
      enableExport: true,
      enableAnalytics: true,
    },
    
    auth: {
      loginType: 'sso', // client-a 使用SSO登录
      ssoUrl: process.env.REACT_APP_SSO_URL || '',
      qrCodeApi: '',
      localLoginApi: '',
    },
    
    content: {
      logo: '/images/logo-client-a.png',
      favicon: '/favicon-client-a.ico',
      title: '政策研究平台',
      description: '专业的政策研究与分析平台',
      keywords: ['政策', '研究', '分析', '智库'],
    },
    
    api: {
      baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api-client-a.example.com',
      timeout: 10000,
      retryCount: 3,
    },
    
    thirdParty: {
      analytics: {
        enabled: true,
        trackingId: 'GA-CLIENT-A-123',
      },
      maps: {
        enabled: true,
        apiKey: process.env.REACT_APP_MAPS_API_KEY,
      },
    },
  },
  
  'client-b': {
    clientId: 'client-b',
    clientName: '甲方B',
    projectName: '政策通',
    version: '1.0.0',
    
    theme: {
      name: 'dark-blue',
      primary: 'rgb(26,54,93)',
      primaryHover: 'rgb(45,122,160)',
      accent: 'rgb(45,122,160)',
      neutral: 'rgb(45,122,160)',
      background: 'rgb(45,122,160)',
      surface:'rgb(45,122,160)',
      text: 'rgb(26,54,93)',
      textSecondary: 'rgb(45,122,160)',
      button:'rgb(45,122,160)'
    },
    
    layout: {
      headerHeight: '72px',
      sidebarWidth: '320px',
      sidebarCollapsedWidth: '100px',
      footerHeight: '80px',
      maxContentWidth: '1400px',
      borderRadius: '12px',
      shadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    },
    
    components: {
      button: {
        primary: {
          backgroundColor: '#1e3a8a',
          color: '#ffffff',
          hoverBackgroundColor: '#1e40af',
        },
        secondary: {
          backgroundColor: '#e2e8f0',
          color: '#334155',
          hoverBackgroundColor: '#cbd5e1',
        },
      },
      card: {
        backgroundColor: '#ffffff',
        borderColor: '#e2e8f0',
        shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      },
      navigation: {
        backgroundColor: '#ffffff',
        activeColor: '#1e3a8a',
        hoverColor: '#f1f5f9',
      },
    },
    
    features: {
      enableSearch: true,
      enableTimeline: true,
      enableCollections: true,
      enableSharing: false,
      enableExport: true,
      enableAnalytics: true,
    },
    
    auth: {
      loginType: 'local', // client-b 使用本地登录页面
      ssoUrl: '',
      qrCodeApi: process.env.REACT_APP_OR_LOGIN_API_URL || '',
      localLoginApi: process.env.REACT_APP_LOGIN_API_URL || '',
    },
    
    content: {
      logo: '/images/logo-client-b.png',
      favicon: '/favicon-client-b.ico',
      title: '政策通',
      description: '专业的政策研究与分析平台',
      keywords: ['政策', '智库', '研究', '分析', '决策'],
    },
    
    api: {
      baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api-client-b.example.com',
      timeout: 15000,
      retryCount: 5,
    },
    
    thirdParty: {
      analytics: {
        enabled: true,
        trackingId: 'GA-CLIENT-B-456',
      },
      maps: {
        enabled: false,
        apiKey: null,
      },
    },
  },
};

/**
 * 配置上下文
 */
const ConfigContext = createContext(null);

/**
 * 配置提供者组件
 */
export const ConfigProvider = ({ children }) => {
  // 从环境变量获取客户端ID
  const clientId = process.env.REACT_APP_CLIENT_ID || process.env.CLIENT_ID || 'client-a';
  
  // 获取当前客户端配置
  const currentConfig = useMemo(() => {
    const config = CLIENT_CONFIGS[clientId] || CLIENT_CONFIGS['client-a'];
    return {
      ...config,
      clientId,
    };
  }, [clientId]);
  
  // 将主题配置转换为CSS变量
  useEffect(() => {
    const root = document.documentElement;
    const theme = currentConfig.theme;
    
    // 定义CSS变量
    const cssVariables = {
      // 主题变量
      '--primary-color': theme.primary,
      '--primary-hover-color': theme.primaryHover,
      '--accent-color': theme.accent,
      '--neutral-color': theme.neutral,
      '--background-color': theme.background,
      '--surface-color': theme.surface,
      '--text-color': theme.text,
      '--text-secondary-color': theme.textSecondary,
      
      // RGB格式的主色调（用于rgba函数）
      '--primary-color-rgb': theme.primary.replace(/rgb\(|\)/g, '').replace(/\s/g, ''),
      
      // 布局变量
      '--header-height': currentConfig.layout.headerHeight,
      '--sidebar-width': currentConfig.layout.sidebarWidth,
      '--sidebar-collapsed-width': currentConfig.layout.sidebarCollapsedWidth,
      '--footer-height': currentConfig.layout.footerHeight,
      '--max-content-width': currentConfig.layout.maxContentWidth,
      '--border-radius': currentConfig.layout.borderRadius,
      '--shadow': currentConfig.layout.shadow,
      
      // 组件变量
      '--button-primary-bg': currentConfig.components.button.primary.backgroundColor,
      '--button-primary-color': currentConfig.components.button.primary.color,
      '--button-primary-hover-bg': currentConfig.components.button.primary.hoverBackgroundColor,
      '--button-secondary-bg': currentConfig.components.button.secondary.backgroundColor,
      '--button-secondary-color': currentConfig.components.button.secondary.color,
      '--button-secondary-hover-bg': currentConfig.components.button.secondary.hoverBackgroundColor,
      
      '--card-bg': currentConfig.components.card.backgroundColor,
      '--card-border-color': currentConfig.components.card.borderColor,
      '--card-shadow': currentConfig.components.card.shadow,
      
      '--nav-bg': currentConfig.components.navigation.backgroundColor,
      '--nav-active-color': currentConfig.components.navigation.activeColor,
      '--nav-hover-color': currentConfig.components.navigation.hoverColor,
    };
    
    // 应用CSS变量到根元素
    Object.entries(cssVariables).forEach(([property, value]) => {
      root.style.setProperty(property, value);
    });
    
    // 设置DaisyUI主题
    document.documentElement.setAttribute('data-theme', theme.name);
    
    // 强制刷新CSS变量 - 使用!important确保优先级
    document.documentElement.style.setProperty('--primary', theme.primary + ' !important');
    document.documentElement.style.setProperty('--primary-focus', theme.primaryHover + ' !important');
    document.documentElement.style.setProperty('--primary-content', '#ffffff !important');
    
    // 直接设置bg-primary的样式
    const style = document.createElement('style');
    style.id = 'dynamic-theme-styles';
    style.textContent = `
      .bg-primary {
        background-color: ${theme.primary} !important;
      }
      .collapse-title.bg-primary {
        background-color: ${theme.primary} !important;
      }
      .text-primary {
        color: ${theme.primary} !important;
      }
      .tab-active {
        color: ${theme.primary} !important;
      }
      .tab-active.text-primary {
        color: ${theme.primary} !important;
      }
      .btn-active {
        background-color: ${theme.primary} !important;
        color: #ffffff !important;
      }
      .btn-primary {
        background-color: ${theme.primary} !important;
        color: #ffffff !important;
      }
      .hover\\:btn-primary:hover {
        background-color: ${theme.primaryHover} !important;
        color: #ffffff !important;
      }
      .from-primary {
        background: linear-gradient(to right, ${theme.primary}, ${theme.primary}90) !important;
      }
      .to-primary\\/90 {
        background: linear-gradient(to right, ${theme.primary}, ${theme.primary}90) !important;
      }
      .hover\\:from-primary\\/90:hover {
        background: linear-gradient(to right, ${theme.primary}90, ${theme.primary}) !important;
      }
      .hover\\:to-primary:hover {
        background: linear-gradient(to right, ${theme.primary}90, ${theme.primary}) !important;
      }
      .tabs-bordered .tab.tab-active {
        border-color: ${theme.text} !important;
        color: ${theme.text} !important;
      }
      .tabs-bordered .tab-active {
        border-color: ${theme.text} !important;
        color: ${theme.text} !important;
      }
      .tabs-bordered .tab.text-primary {
        border-color: ${theme.text} !important;
        color: ${theme.text} !important;
      }
      .btn-link {
        color: ${theme.text} !important;
      }
      .btn-link:hover {
        color: ${theme.text} !important;
        text-decoration: underline;
      }
      .btn.text-lg.btn-link {
        color: ${theme.text} !important;
      }
      .btn.text-lg.btn-link:hover {
        color: ${theme.text} !important;
        text-decoration: underline;
      }
      .card[style*="background-color"] {
        background-color: ${theme.primary} !important;
      }
      .card.image-full[style*="background-color"] {
        background-color: ${theme.primary} !important;
      }
      .card.shadow-xl[style*="background-color"] {
        background-color: ${theme.primary} !important;
      }
      .card.image-full.shadow-xl[style*="background-color"] {
        background-color: ${theme.primary} !important;
      }
      .border-primary {
        border-color: ${theme.primary} !important;
      }
      .border-l-4.border-primary {
        border-left-color: ${theme.primary} !important;
      }
      .border-2.border-primary {
        border-color: ${theme.primary} !important;
      }
      .mainContainer {
        background-image: url(https://img.daisyui.com/images/stock/photo-1481026469463-66327c86e544.webp);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: fixed;
      }
      .mainContainer .bg-base-100,
      .mainContainer .bg-base-200,
      .mainContainer .bg-white,
      .mainContainer .card,
      .mainContainer .navbar {
        background-color: rgba(255, 255, 255, 0.7) !important;
        backdrop-filter: blur(8px);
      }
      .mainContainer .shadow-lg {
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
      }
    `;
    
    // 移除旧的样式
    const oldStyle = document.getElementById('dynamic-theme-styles');
    if (oldStyle) {
      oldStyle.remove();
    }
    
    document.head.appendChild(style);
    
    // 检查DaisyUI主题是否正确应用
    setTimeout(() => {
        const root = document.documentElement;
        const computedStyle = getComputedStyle(root);
        console.log('DaisyUI CSS变量检查:');
        console.log('--primary:', computedStyle.getPropertyValue('--primary'));
        console.log('--primary-focus:', computedStyle.getPropertyValue('--primary-focus'));
        console.log('--primary-content:', computedStyle.getPropertyValue('--primary-content'));
        
        // 检查bg-primary的实际颜色
        const testElement = document.createElement('div');
        testElement.className = 'bg-primary';
        testElement.style.position = 'absolute';
        testElement.style.left = '-9999px';
        document.body.appendChild(testElement);
        const bgColor = getComputedStyle(testElement).backgroundColor;
        console.log('bg-primary 实际颜色:', bgColor);
        document.body.removeChild(testElement);
    }, 100);
    
    // 设置页面标题和描述
    document.title = currentConfig.content.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', currentConfig.content.description);
    }
    
    // 设置favicon
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon && currentConfig.content.favicon) {
      favicon.setAttribute('href', currentConfig.content.favicon);
    }
    
  }, [currentConfig]);
  
  return (
    <ConfigContext.Provider value={currentConfig}>
      {children}
    </ConfigContext.Provider>
  );
};

/**
 * 使用配置Hook
 */
export const useConfig = () => {
  const context = useContext(ConfigContext);
  
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  
  return {
    // 基础配置
    clientId: context.clientId,
    clientName: context.clientName,
    projectName: context.projectName,
    version: context.version,
    
    // 主题配置
    theme: context.theme,
    
    // 布局配置
    layout: context.layout,
    
    // 组件配置
    components: context.components,
    
    // 功能配置
    features: context.features,
    
    // 认证配置
    auth: context.auth,
    
    // 内容配置
    content: context.content,
    
    // API配置
    api: context.api,
    
    // 第三方服务配置
    thirdParty: context.thirdParty,
    
    // 完整配置对象
    config: context,
    
    // 工具方法
    isFeatureEnabled: (featureName) => {
      return context.features[featureName] === true;
    },
    
    getThemeColor: (colorName) => {
      return context.theme[colorName];
    },
    
    getLayoutValue: (propertyName) => {
      return context.layout[propertyName];
    },
    
    getComponentStyle: (componentName, styleName) => {
      return context.components[componentName]?.[styleName];
    },
    
    // 获取CSS变量值
    getCSSVariable: (variableName) => {
      return getComputedStyle(document.documentElement).getPropertyValue(variableName);
    },
  };
};

/**
 * 配置验证器
 */
export const validateConfig = (config) => {
  const requiredFields = [
    'clientId',
    'clientName',
    'projectName',
    'theme',
    'layout',
    'components',
    'features',
    'content',
    'api'
  ];
  
  const missingFields = requiredFields.filter(field => !config[field]);
  
  if (missingFields.length > 0) {
    console.warn(`配置缺少必要字段: ${missingFields.join(', ')}`);
    return false;
  }
  
  return true;
};

/**
 * 获取所有可用客户端配置
 */
export const getAvailableClients = () => {
  return Object.keys(CLIENT_CONFIGS);
};

/**
 * 获取特定客户端配置
 */
export const getClientConfig = (clientId) => {
  return CLIENT_CONFIGS[clientId] || CLIENT_CONFIGS['client-a'];
};